import { CIcon } from '~/icons/types'

export const ciContainers: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.978 11.253h-2.226l-7.486-2.791a1.8 1.8 0 0 0 .123-2.26 1.773 1.773 0 0 0-.901-.646v-.462h.8a.731.731 0 0 0 .722-.74V3.24a.72.72 0 0 0-.717-.74h-2.577a.73.73 0 0 0-.722.74v1.11a.73.73 0 0 0 .722.739h.8v.894a.5.5 0 0 0 .493.5.769.769 0 1 1-.75.769.493.493 0 1 0-.985 0c0 .446.165.875.464 1.206l-7.48 2.795H1.03a1 1 0 0 0-.984 1.009v8.229A1 1 0 0 0 1.03 21.5h21.938a1 1 0 0 0 .984-1.009v-8.234a.99.99 0 0 0-.975-1.004Zm-12-7.172V3.5h2.058v.577l-2.058.004ZM12 9.057l5.874 2.191H6.13L12 9.057ZM1.03 20.491v-8.229h21.943v8.229H1.03Z'
    },
    {
      d:
        'M3.342 13.035a.5.5 0 0 0-.492.5V19.2a.493.493 0 1 0 .985 0v-5.66a.5.5 0 0 0-.493-.505Zm2.892 0a.5.5 0 0 0-.492.5V19.2a.493.493 0 1 0 .985 0v-5.66a.5.5 0 0 0-.493-.505Zm2.883 0a.5.5 0 0 0-.492.5V19.2a.492.492 0 0 0 .984 0v-5.66a.5.5 0 0 0-.492-.505Zm2.883 0a.5.5 0 0 0-.492.5V19.2a.492.492 0 0 0 .984 0v-5.66a.5.5 0 0 0-.492-.505Zm2.892 0a.5.5 0 0 0-.492.5V19.2a.492.492 0 0 0 .984 0v-5.66a.5.5 0 0 0-.492-.505Zm2.883 0a.5.5 0 0 0-.492.5V19.2a.492.492 0 0 0 .984 0v-5.66a.5.5 0 0 0-.492-.505Zm2.888 0a.5.5 0 0 0-.492.5V19.2a.492.492 0 0 0 .984 0v-5.66a.5.5 0 0 0-.492-.505Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'containers',
  type: 'thin'
}
